import React from "react";

interface Venture {
  name: string;
  profit: number;
  expenses: number;
  color: string;
}

const format = (n: number) =>
  n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });

const BusinessList = ({ ventures, onSelectVenture }: { ventures: Venture[]; onSelectVenture?: (v: Venture) => void }) => {
  // Find maximum profit for styling bars
  const maxProfit = Math.max(...ventures.map(v => v.profit), 1);

  return (
    <div className="mt-1 w-full max-w-md flex flex-col divide-y divide-border rounded-lg bg-card shadow mb-8">
      {ventures.map((v) => (
        <button
          key={v.name}
          className="flex items-center gap-4 px-5 py-3 w-full bg-transparent hover:bg-muted focus:bg-muted/80 rounded transition group outline-none text-left"
          onClick={() => onSelectVenture && onSelectVenture(v)}
          tabIndex={0}
        >
          <div
            className="w-2.5 h-8 rounded bg-opacity-60"
            style={{ background: v.color }}
          ></div>
          <div className="flex flex-col flex-1 justify-center gap-1 min-w-0">
            <span className="font-medium text-primary truncate text-base group-hover:underline">{v.name}</span>
            <div className="h-2.5 rounded bg-muted relative overflow-hidden">
              <div
                className="h-2.5 rounded transition-all duration-700"
                style={{ width: `${(v.profit / maxProfit) * 100}%`, background: v.color }}
              />
            </div>
          </div>
          <div className="flex flex-col items-end min-w-[80px]">
            <span className="font-bold text-primary text-sm">{format(v.profit)}</span>
            <span className="text-xs text-muted-foreground">Profit</span>
          </div>
        </button>
      ))}
    </div>
  );
};

export default BusinessList;